import './scss/main.scss';

var $ = window.jQuery;

function handleResize() {
  $('iframe').each(function() {
    var width = parseInt($(this).attr('width'));
    var height = parseInt($(this).attr('height'));
    var ratio = 1;
    if (width && height) {
      ratio = width / height;
    }
    $(this).height($(this).width() / ratio);
  });
}

$('.accordeon').each(function() {
  $(this)
    .find('.content')
    .slideUp();
  $(this)
    .find('.heading')
    .click(function() {
      if ($(this).data('open')) {
        $(this).data('open', false);
        $(this)
          .parent()
          .find('.content')
          .slideUp();
      } else {
        $(this).data('open', true);
        $(this)
          .parent()
          .find('.content')
          .slideDown();
      }
    });
});

$(window).resize(handleResize);
handleResize();

if (
  document.querySelector('.open-inquiry-form') ||
  document.querySelector('#edic-inquiry-form')
) {
  EdicApi.initInquiryForm();
}

if (document.querySelector('#origin-input')) {
  document
    .getElementById('origin-input')
    .setAttribute('value', 'https://die-durchstarter.de');
}
